// extracted by mini-css-extract-plugin
export var modal = "_55-0";